import React from "react";



export default function Container(props)
{
    return(
        <div>
            {props.children}
        </div>
    )
}
